/** Textos de Eventos (FASE 4). */
const S = {
	title: "Eventos",
	nuevo: "Nuevo Evento",
	volver: "Volver",
	cerrar: "Cerrar",
	buscar: "Buscar evento",
	cargando: "Cargando…",
	vacio: "Sin eventos con ese filtro.",
	todos: "Todos",
	tipos: { graduacion: "Graduación", batalla: "Batalla", seminario: "Seminario", otro: "Otro" } as { [k: string]: string },
	estados: { programado: "Programado", realizado: "Realizado", anulado: "Anulado", historico: "Histórico" } as { [k: string]: string },
	col: { fecha: "Fecha", evento: "Evento", tipo: "Tipo", lugar: "Lugar", asistentes: "Asistentes", paquete: "Paquete", estado: "Estado" },
	// Formulario
	editar: "Editar",
	guardar: "Guardar",
	crear: "Crear Evento",
	tipo: "Tipo",
	nombre: "Nombre",
	fecha: "Fecha y hora",
	lugar: "Lugar",
	cupo: "Cupo",
	porMesa: "Personas por mesa",
	paquete: "Paquete graduada",
	invitadoExtra: "Invitado extra",
	nino: "Niño",
	costos: "Costos",
	concepto: "Concepto",
	monto: "Monto",
	agregarCosto: "Agregar Costo",
	quitar: "Quitar",
	notas: "Notas",
	estado: "Estado",
	guardado: "Evento guardado.",
	creado: "Evento creado.",
	historicoAviso: "Evento histórico: solo lectura.",
	// Pestañas
	tabs: { asistentes: "Asistentes", elegibles: "Elegibles", invitaciones: "Invitaciones", entrada: "Entrada", resultado: "Resultado" },
	// Asistentes
	colNo: "No.",
	colNombre: "Nombre",
	colTipo: "Tipo",
	colMesa: "Mesa",
	colPago: "Pago",
	colFoto: "Foto",
	colDiploma: "Diploma",
	colEntrada: "Entrada",
	pagado: "Pagado",
	porPagar: "Por pagar",
	sinCobro: "Sin cobro",
	diplomaListo: "Listo",
	falta: (x: string[]) => "Falta: " + x.join(", "),
	subirFoto: "Subir Foto",
	cambiarFoto: "Cambiar",
	verFoto: "Ver",
	fotoOk: "Foto guardada.",
	invitacionPdf: "Invitación",
	diplomaPdf: "Diploma",
	baja: "Baja",
	bajaTitulo: (n: string) => `Baja de ${n}`,
	bajaNota: "Nota",
	bajaOk: "Dada de baja.",
	invitaA: (n: string) => `Invita ${n}`,
	agregarAsistente: "Agregar Asistente",
	kinds: { graduada: "Graduada", invitado: "Invitado", especial: "Especial", externo: "Externo", participante: "Participante" } as { [k: string]: string },
	motivoPrecio: "Motivo",
	precioEvento: "Precio del evento",
	invitaGraduada: "Graduada que invita",
	elegir: "Elegir…",
	esNino: "Niño",
	precio: "Precio",
	seCobra: "Se cobra",
	buscarAlumna: "Nombre o código de la alumna",
	buscarBtn: "Buscar",
	agregarBtn: "Agregar",
	agregado: "Asistente agregado.",
	sinAsistentes: "Sin asistentes.",
	vigentes: (n: number) => `${n} vigentes`,
	repartirMesas: "Repartir Mesas",
	repartirTitulo: "Repartir Mesas",
	conservarManuales: "Conservar las mesas puestas a mano",
	repartir: "Repartir",
	mesasOk: "Mesas repartidas.",
	verQr: "Ver QR",
	qrDe: (n: string) => `QR de ${n}`,
	// Invitaciones
	pdfTodas: "PDF de Todas",
	whatsappVarias: (n: number) => `WhatsApp a ${n}`,
	colWhatsapp: "WhatsApp",
	colEnlace: "Enlace",
	copiar: "Copiar",
	copiado: "Copiado.",
	sinTelefono: "Sin teléfono",
	seleccionadas: (n: number) => `${n} elegidas`,
	// Elegibles
	elegTodas: "Todas",
	elegListas: "Diploma Listo",
	elegReponer: "Por Reponer",
	cursoTodos: "Todos los cursos",
	buscarElegible: "Buscar alumna",
	colCurso: "Curso",
	colTermina: "Termina",
	colAsistencia: "Asistencia",
	colEstado: "Estado",
	nPorReponer: (n: number) => `${n} por reponer`,
	yaAgregada: "Agregada",
	agregarN: (n: number) => `Agregar ${n}`,
	cobraPaquete: "Se cobra el paquete",
	agregadas: (a: number, s: number) => `Agregadas ${a}` + (s ? ` · sin agregar ${s}` : "") + ".",
	mostrando: (n: number, t: number) => `${n} de ${t}`,
	// Entrada
	codigo: "Código QR",
	leer: "Leer",
	escanearCamara: "Escanear con Cámara",
	camaraTitulo: "Escanear Invitación",
	camaraPrendiendo: "Prendiendo la cámara…",
	camaraSinPermiso: "Permite la cámara en el navegador y vuelve a abrir.",
	camaraNoSoporta: "Este navegador no puede usar la cámara.",
	camaraApunta: "Apunta al código QR",
	cerrarCamara: "Cerrar",
	entradas: (n: number, t: number) => `${n} de ${t} adentro`,
	rehabilitar: "Re-habilitar",
	rehabTitulo: (n: string) => `Re-habilitar a ${n}`,
	rehabNota: "Motivo",
	rehabOk: "Invitación re-habilitada.",
	lecturas: "Lecturas",
	acciones: { entrada: "Entrada", rechazada: "Rechazada", rehabilitada: "Re-habilitada" } as { [k: string]: string },
	// Resultado
	ingresos: "Ingresos",
	cobrado: "Cobrado",
	pendiente: "Pendiente",
	costosTotal: "Costos",
	bruto: "Bruto",
	brutoCobrado: "Bruto cobrado",
	porTipo: "Por tipo",
	cantidad: "Cantidad",
	mesas: "Mesas",
	togas: "Togas y Birretes",
	asistentesVigentes: "Asistentes"
};

export default S;
